(function(){"use strict";try{if(typeof document<"u"){var t=document.createElement("style");t.appendChild(document.createTextNode(".react-final-marquee{overflow:hidden;position:relative;height:100%;min-height:var(--marquee-container-height);background-color:var(--marquee-background-color);color:var(--marquee-text-color);white-space:nowrap}.react-final-marquee-wrapper{position:absolute;display:flex;align-items:center;height:100%}.react-final-marquee-wrapper[data-direction=rightToLeft] .react-final-marquee-item{-webkit-transform:translateX(100%);transform:translate(100%);padding-right:var(--space);-webkit-animation-name:marqee-rightToLeft;animation-name:marqee-rightToLeft}.react-final-marquee-wrapper[data-direction=leftToRight] .react-final-marquee-item{float:right;padding-left:var(--space);-webkit-animation-name:marqee-leftToRight;animation-name:marqee-leftToRight}.react-final-marquee-wrapper[data-direction=bottomToTop] .react-final-marquee-item{-webkit-animation-name:marqee-bottomToTop;animation-name:marqee-bottomToTop;padding-bottom:var(--space)}.react-final-marquee-wrapper[data-direction=topToBottom] .react-final-marquee-item{-webkit-animation-name:marqee-topToBottom;animation-name:marqee-topToBottom;padding-bottom:var(--space)}.react-final-marquee-wrapper[data-direction=bottomToTop],.react-final-marquee-wrapper[data-direction=topToBottom]{flex-direction:column}.react-final-marquee-wrapper[data-direction=rightToLeft]{left:0px}.react-final-marquee-wrapper[data-direction=leftToRight]{right:0px}.react-final-marquee-wrapper[data-position=start]{top:0px}.react-final-marquee-wrapper[data-position=center]{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.react-final-marquee-wrapper[data-position=end]{bottom:0px}.react-final-marquee-wrapper[data-direction=topToBottom][data-position=start],.react-final-marquee-wrapper[data-direction=bottomToTop][data-position=start]{top:0px;left:0px}.react-final-marquee-wrapper[data-direction=topToBottom][data-position=center],.react-final-marquee-wrapper[data-direction=bottomToTop][data-position=center]{top:0px;left:50%;-webkit-transform:translateY(0%) translateX(-50%);transform:translateY(0) translate(-50%)}.react-final-marquee-wrapper[data-direction=topToBottom][data-position=end],.react-final-marquee-wrapper[data-direction=bottomToTop][data-position=end]{top:0px;right:0px}.react-final-marquee-item{float:left;-webkit-animation-play-state:var(--play);animation-play-state:var(--play);-webkit-animation-duration:var(--duration);animation-duration:var(--duration);-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:linear;animation-timing-function:linear;height:100%}.react-final-marquee:hover .react-final-marquee-item{-webkit-animation-play-state:var(--pause-on-hover);animation-play-state:var(--pause-on-hover)}@-webkit-keyframes marqee-rightToLeft{0%{-webkit-transform:translateX(0);transform:translate(0)}to{-webkit-transform:translateX(-100%);transform:translate(-100%)}}@keyframes marqee-rightToLeft{0%{-webkit-transform:translateX(0);transform:translate(0)}to{-webkit-transform:translateX(-100%);transform:translate(-100%)}}@-webkit-keyframes marqee-leftToRight{0%{-webkit-transform:translateX(0%);transform:translate(0)}to{-webkit-transform:translateX(100%);transform:translate(100%)}}@keyframes marqee-leftToRight{0%{-webkit-transform:translateX(0%);transform:translate(0)}to{-webkit-transform:translateX(100%);transform:translate(100%)}}@-webkit-keyframes marqee-bottomToTop{0%{-webkit-transform:translateY(0%);transform:translateY(0)}to{-webkit-transform:translateY(-100%);transform:translateY(-100%)}}@keyframes marqee-bottomToTop{0%{-webkit-transform:translateY(0%);transform:translateY(0)}to{-webkit-transform:translateY(-100%);transform:translateY(-100%)}}@-webkit-keyframes marqee-topToBottom{0%{-webkit-transform:translateY(-100%);transform:translateY(-100%)}to{-webkit-transform:translateY(0%);transform:translateY(0)}}@keyframes marqee-topToBottom{0%{-webkit-transform:translateY(-100%);transform:translateY(-100%)}to{-webkit-transform:translateY(0%);transform:translateY(0)}}")),document.head.appendChild(t)}}catch(a){console.error("vite-plugin-css-injected-by-js",a)}})();
import Le, { useState as fe, useEffect as Z, useRef as le, forwardRef as dr } from "react";
var U = {}, vr = {
  get exports() {
    return U;
  },
  set exports(s) {
    U = s;
  }
}, V = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $e;
function pr() {
  if ($e)
    return V;
  $e = 1;
  var s = Le, v = Symbol.for("react.element"), y = Symbol.for("react.fragment"), b = Object.prototype.hasOwnProperty, P = s.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, T = { key: !0, ref: !0, __self: !0, __source: !0 };
  function _(p, c, h) {
    var g, E = {}, w = null, D = null;
    h !== void 0 && (w = "" + h), c.key !== void 0 && (w = "" + c.key), c.ref !== void 0 && (D = c.ref);
    for (g in c)
      b.call(c, g) && !T.hasOwnProperty(g) && (E[g] = c[g]);
    if (p && p.defaultProps)
      for (g in c = p.defaultProps, c)
        E[g] === void 0 && (E[g] = c[g]);
    return { $$typeof: v, type: p, key: w, ref: D, props: E, _owner: P.current };
  }
  return V.Fragment = y, V.jsx = _, V.jsxs = _, V;
}
var M = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ie;
function hr() {
  return Ie || (Ie = 1, process.env.NODE_ENV !== "production" && function() {
    var s = Le, v = Symbol.for("react.element"), y = Symbol.for("react.portal"), b = Symbol.for("react.fragment"), P = Symbol.for("react.strict_mode"), T = Symbol.for("react.profiler"), _ = Symbol.for("react.provider"), p = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), D = Symbol.for("react.offscreen"), F = Symbol.iterator, Q = "@@iterator";
    function ee(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = F && e[F] || e[Q];
      return typeof r == "function" ? r : null;
    }
    var S = s.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function d(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
          t[n - 1] = arguments[n];
        B("error", e, t);
      }
    }
    function B(e, r, t) {
      {
        var n = S.ReactDebugCurrentFrame, o = n.getStackAddendum();
        o !== "" && (r += "%s", t = t.concat([o]));
        var u = t.map(function(i) {
          return String(i);
        });
        u.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, u);
      }
    }
    var A = !1, $ = !1, I = !1, W = !1, re = !1, z;
    z = Symbol.for("react.module.reference");
    function C(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === b || e === T || re || e === P || e === h || e === g || W || e === D || A || $ || I || typeof e == "object" && e !== null && (e.$$typeof === w || e.$$typeof === E || e.$$typeof === _ || e.$$typeof === p || e.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === z || e.getModuleId !== void 0));
    }
    function j(e, r, t) {
      var n = e.displayName;
      if (n)
        return n;
      var o = r.displayName || r.name || "";
      return o !== "" ? t + "(" + o + ")" : t;
    }
    function de(e) {
      return e.displayName || "Context";
    }
    function O(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && d("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case b:
          return "Fragment";
        case y:
          return "Portal";
        case T:
          return "Profiler";
        case P:
          return "StrictMode";
        case h:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case p:
            var r = e;
            return de(r) + ".Consumer";
          case _:
            var t = e;
            return de(t._context) + ".Provider";
          case c:
            return j(e, e.render, "ForwardRef");
          case E:
            var n = e.displayName || null;
            return n !== null ? n : O(e.type) || "Memo";
          case w: {
            var o = e, u = o._payload, i = o._init;
            try {
              return O(i(u));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var k = Object.assign, L = 0, ve, pe, he, ge, me, ye, Re;
    function Ee() {
    }
    Ee.__reactDisabledLog = !0;
    function qe() {
      {
        if (L === 0) {
          ve = console.log, pe = console.info, he = console.warn, ge = console.error, me = console.group, ye = console.groupCollapsed, Re = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Ee,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        L++;
      }
    }
    function Ve() {
      {
        if (L--, L === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: k({}, e, {
              value: ve
            }),
            info: k({}, e, {
              value: pe
            }),
            warn: k({}, e, {
              value: he
            }),
            error: k({}, e, {
              value: ge
            }),
            group: k({}, e, {
              value: me
            }),
            groupCollapsed: k({}, e, {
              value: ye
            }),
            groupEnd: k({}, e, {
              value: Re
            })
          });
        }
        L < 0 && d("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var te = S.ReactCurrentDispatcher, ne;
    function H(e, r, t) {
      {
        if (ne === void 0)
          try {
            throw Error();
          } catch (o) {
            var n = o.stack.trim().match(/\n( *(at )?)/);
            ne = n && n[1] || "";
          }
        return `
` + ne + e;
      }
    }
    var ae = !1, J;
    {
      var Me = typeof WeakMap == "function" ? WeakMap : Map;
      J = new Me();
    }
    function be(e, r) {
      if (!e || ae)
        return "";
      {
        var t = J.get(e);
        if (t !== void 0)
          return t;
      }
      var n;
      ae = !0;
      var o = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var u;
      u = te.current, te.current = null, qe();
      try {
        if (r) {
          var i = function() {
            throw Error();
          };
          if (Object.defineProperty(i.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(i, []);
            } catch (x) {
              n = x;
            }
            Reflect.construct(e, [], i);
          } else {
            try {
              i.call();
            } catch (x) {
              n = x;
            }
            e.call(i.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (x) {
            n = x;
          }
          e();
        }
      } catch (x) {
        if (x && n && typeof x.stack == "string") {
          for (var a = x.stack.split(`
`), m = n.stack.split(`
`), f = a.length - 1, l = m.length - 1; f >= 1 && l >= 0 && a[f] !== m[l]; )
            l--;
          for (; f >= 1 && l >= 0; f--, l--)
            if (a[f] !== m[l]) {
              if (f !== 1 || l !== 1)
                do
                  if (f--, l--, l < 0 || a[f] !== m[l]) {
                    var R = `
` + a[f].replace(" at new ", " at ");
                    return e.displayName && R.includes("<anonymous>") && (R = R.replace("<anonymous>", e.displayName)), typeof e == "function" && J.set(e, R), R;
                  }
                while (f >= 1 && l >= 0);
              break;
            }
        }
      } finally {
        ae = !1, te.current = u, Ve(), Error.prepareStackTrace = o;
      }
      var Y = e ? e.displayName || e.name : "", Ae = Y ? H(Y) : "";
      return typeof e == "function" && J.set(e, Ae), Ae;
    }
    function Ue(e, r, t) {
      return be(e, !1);
    }
    function Be(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function G(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return be(e, Be(e));
      if (typeof e == "string")
        return H(e);
      switch (e) {
        case h:
          return H("Suspense");
        case g:
          return H("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case c:
            return Ue(e.render);
          case E:
            return G(e.type, r, t);
          case w: {
            var n = e, o = n._payload, u = n._init;
            try {
              return G(u(o), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var K = Object.prototype.hasOwnProperty, _e = {}, Te = S.ReactDebugCurrentFrame;
    function X(e) {
      if (e) {
        var r = e._owner, t = G(e.type, e._source, r ? r.type : null);
        Te.setExtraStackFrame(t);
      } else
        Te.setExtraStackFrame(null);
    }
    function ze(e, r, t, n, o) {
      {
        var u = Function.call.bind(K);
        for (var i in e)
          if (u(e, i)) {
            var a = void 0;
            try {
              if (typeof e[i] != "function") {
                var m = Error((n || "React class") + ": " + t + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[i] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw m.name = "Invariant Violation", m;
              }
              a = e[i](r, i, n, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (f) {
              a = f;
            }
            a && !(a instanceof Error) && (X(o), d("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", t, i, typeof a), X(null)), a instanceof Error && !(a.message in _e) && (_e[a.message] = !0, X(o), d("Failed %s type: %s", t, a.message), X(null));
          }
      }
    }
    var He = Array.isArray;
    function ie(e) {
      return He(e);
    }
    function Je(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function Ge(e) {
      try {
        return we(e), !1;
      } catch {
        return !0;
      }
    }
    function we(e) {
      return "" + e;
    }
    function Se(e) {
      if (Ge(e))
        return d("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Je(e)), we(e);
    }
    var q = S.ReactCurrentOwner, Ke = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ce, Oe, oe;
    oe = {};
    function Xe(e) {
      if (K.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Ze(e) {
      if (K.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Qe(e, r) {
      if (typeof e.ref == "string" && q.current && r && q.current.stateNode !== r) {
        var t = O(q.current.type);
        oe[t] || (d('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', O(q.current.type), e.ref), oe[t] = !0);
      }
    }
    function er(e, r) {
      {
        var t = function() {
          Ce || (Ce = !0, d("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function rr(e, r) {
      {
        var t = function() {
          Oe || (Oe = !0, d("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var tr = function(e, r, t, n, o, u, i) {
      var a = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: v,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: i,
        // Record the component responsible for creating this element.
        _owner: u
      };
      return a._store = {}, Object.defineProperty(a._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(a, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: n
      }), Object.defineProperty(a, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: o
      }), Object.freeze && (Object.freeze(a.props), Object.freeze(a)), a;
    };
    function nr(e, r, t, n, o) {
      {
        var u, i = {}, a = null, m = null;
        t !== void 0 && (Se(t), a = "" + t), Ze(r) && (Se(r.key), a = "" + r.key), Xe(r) && (m = r.ref, Qe(r, o));
        for (u in r)
          K.call(r, u) && !Ke.hasOwnProperty(u) && (i[u] = r[u]);
        if (e && e.defaultProps) {
          var f = e.defaultProps;
          for (u in f)
            i[u] === void 0 && (i[u] = f[u]);
        }
        if (a || m) {
          var l = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          a && er(i, l), m && rr(i, l);
        }
        return tr(e, a, m, o, n, q.current, i);
      }
    }
    var ue = S.ReactCurrentOwner, xe = S.ReactDebugCurrentFrame;
    function N(e) {
      if (e) {
        var r = e._owner, t = G(e.type, e._source, r ? r.type : null);
        xe.setExtraStackFrame(t);
      } else
        xe.setExtraStackFrame(null);
    }
    var se;
    se = !1;
    function ce(e) {
      return typeof e == "object" && e !== null && e.$$typeof === v;
    }
    function Pe() {
      {
        if (ue.current) {
          var e = O(ue.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function ar(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""), t = e.lineNumber;
          return `

Check your code at ` + r + ":" + t + ".";
        }
        return "";
      }
    }
    var je = {};
    function ir(e) {
      {
        var r = Pe();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function ke(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = ir(r);
        if (je[t])
          return;
        je[t] = !0;
        var n = "";
        e && e._owner && e._owner !== ue.current && (n = " It was passed a child from " + O(e._owner.type) + "."), N(e), d('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, n), N(null);
      }
    }
    function De(e, r) {
      {
        if (typeof e != "object")
          return;
        if (ie(e))
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            ce(n) && ke(n, r);
          }
        else if (ce(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var o = ee(e);
          if (typeof o == "function" && o !== e.entries)
            for (var u = o.call(e), i; !(i = u.next()).done; )
              ce(i.value) && ke(i.value, r);
        }
      }
    }
    function or(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === E))
          t = r.propTypes;
        else
          return;
        if (t) {
          var n = O(r);
          ze(t, e.props, "prop", n, e);
        } else if (r.PropTypes !== void 0 && !se) {
          se = !0;
          var o = O(r);
          d("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", o || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && d("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ur(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var n = r[t];
          if (n !== "children" && n !== "key") {
            N(e), d("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), N(null);
            break;
          }
        }
        e.ref !== null && (N(e), d("Invalid attribute `ref` supplied to `React.Fragment`."), N(null));
      }
    }
    function Fe(e, r, t, n, o, u) {
      {
        var i = C(e);
        if (!i) {
          var a = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (a += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var m = ar(o);
          m ? a += m : a += Pe();
          var f;
          e === null ? f = "null" : ie(e) ? f = "array" : e !== void 0 && e.$$typeof === v ? (f = "<" + (O(e.type) || "Unknown") + " />", a = " Did you accidentally export a JSX literal instead of a component?") : f = typeof e, d("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", f, a);
        }
        var l = nr(e, r, t, o, u);
        if (l == null)
          return l;
        if (i) {
          var R = r.children;
          if (R !== void 0)
            if (n)
              if (ie(R)) {
                for (var Y = 0; Y < R.length; Y++)
                  De(R[Y], e);
                Object.freeze && Object.freeze(R);
              } else
                d("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              De(R, e);
        }
        return e === b ? ur(l) : or(l), l;
      }
    }
    function sr(e, r, t) {
      return Fe(e, r, t, !0);
    }
    function cr(e, r, t) {
      return Fe(e, r, t, !1);
    }
    var fr = cr, lr = sr;
    M.Fragment = b, M.jsx = fr, M.jsxs = lr;
  }()), M;
}
(function(s) {
  process.env.NODE_ENV === "production" ? s.exports = pr() : s.exports = hr();
})(vr);
function We(s) {
  return /^-?\d+$/.test(s + "");
}
function gr(s) {
  const v = le(s);
  Z(() => {
    v.current = s;
  }), Z(() => {
    const y = () => {
      typeof v.current == "function" && v.current();
    };
    return requestAnimationFrame(y), window.addEventListener("resize", y, { passive: !0 }), () => {
      window.removeEventListener("resize", y);
    };
  }, []);
}
function Ne(s, v) {
  const [y, b] = fe(), [P, T] = fe(), _ = () => {
    b((p) => {
      var h;
      const c = (h = s.current) == null ? void 0 : h.getBoundingClientRect().width;
      return p !== c ? c : p;
    }), T((p) => {
      var h;
      const c = (h = s.current) == null ? void 0 : h.getBoundingClientRect().height;
      return p !== c ? c : p;
    });
  };
  return gr(() => {
    _();
  }), Z(() => {
    _();
  }, [v]), { width: y, height: P };
}
function Ye(s, v) {
  return typeof s == "function" ? s(v) : s && (s.current = v), s;
}
const yr = dr((s, v) => {
  const {
    height: y = "30px",
    style: b = {},
    className: P = "",
    paused: T = !1,
    pauseOnHover: _ = !0,
    direction: p = "rightToLeft",
    speed: c = 90,
    space: h = 0,
    repeat: g = 2,
    textColor: E = null,
    bgColor: w = null,
    position: D = "start",
    children: F,
    ...Q
  } = s, [ee, S] = fe(0), d = le(null), B = le(null), { width: A, height: $ } = Ne(
    d,
    F
  ), { width: I, height: W } = Ne(
    B,
    F
  );
  Z(() => {
    const C = ["topToBottom", "bottomToTop"].includes(p), j = +c;
    if (C) {
      W !== void 0 && $ !== void 0 && S(
        W < $ ? $ / j : W / j
      );
      return;
    }
    I !== void 0 && A !== void 0 && S(
      I < A ? A / j : I / j
    );
  }, [I, A, W, $]);
  const re = {
    ["--marquee-container-height"]: We(y) ? `${y}px` : y,
    ["--marquee-text-color"]: E,
    ["--marquee-background-color"]: w
  }, z = {
    ["--play"]: T ? "paused" : "running",
    ["--duration"]: `${ee}s`,
    ["--space"]: We(h) ? `${h}px` : h,
    ["--pause-on-hover"]: T || _ ? "paused" : "running",
    ...b
  };
  return /* @__PURE__ */ U.jsx(
    "div",
    {
      className: `${P} react-final-marquee`,
      ref: (C) => {
        Ye(d, C), Ye(v, C);
      },
      style: re,
      ...Q,
      children: /* @__PURE__ */ U.jsx(
        "div",
        {
          className: "react-final-marquee-wrapper",
          "data-direction": p,
          "data-position": D,
          children: Array.from({ length: +g }, (C, j) => j).map((C) => /* @__PURE__ */ U.jsx(
            "div",
            {
              className: "react-final-marquee-item",
              ref: B,
              style: z,
              children: F
            },
            C
          ))
        }
      )
    }
  );
});
export {
  yr as default
};
